import React from "react";
import { createRoot } from "react-dom/client";
import CatalogApp from "./CatalogApp.jsx";
import LegacyPage from "./LegacyPage.jsx";
import { loadHorenContent } from "./horen-content.js";
import { getPageConfig } from "./page-config.js";
import { setupExamWorkspace } from "./exam/workspace-runtime.js";
import { setupCourseDemo } from "./course/demo-runtime.js";
import { refreshSession } from "./client-cache.js";

async function startApp() {
  const params = new URLSearchParams(location.search);
  if (/^\/horen\/?$/.test(location.pathname) && params.has('part') && !document.getElementById('zdeutsch-exam-workspace') && params.get('courseDemo') !== '1') {
    // The protected endpoint validates access; content warms while session/UI scripts load.
    void loadHorenContent({type: params.get('type') === 'audio' ? 'audio' : 'codes', level: params.get('level') || 'b1', theme: params.get('theme') || ''}).catch(() => {});
  }
  // Check the real session before demo/exam frames install their simulated session.
  // This also protects pages opened from the service worker's cached app shell.
  const session = await refreshSession({ force: true }).catch(() => null);
  if (session?.requiresProfileCompletion && location.pathname !== "/complete-profile" && !(/^\/c1\/?$/.test(location.pathname)&&session?.canAccessC1)) {
    location.replace("/complete-profile");
    return;
  }
  setupCourseDemo();
  const examPageName = setupExamWorkspace();

  const courseDemoPages = Object.freeze({
    "/lesen.html": "lesen",
    "/lesen": "lesen",
    "/horen.html": "horen",
    "/horen": "horen",
    "/shreiben.html": "shreiben",
    "/schreiben": "shreiben",
    "/mundlich.html": "mundlich",
    "/sprechen": "mundlich"
  });
  const demoPageName = examPageName || (window.ZDEUTSCH_COURSE_DEMO
    ? courseDemoPages[window.location.pathname.replace(/\/$/, "")]
    : null);
  const demoPage = demoPageName ? getPageConfig(demoPageName) : null;

  const rootElement = document.getElementById("zdeutsch-react-root");

  if (!rootElement) {
    throw new Error("The ZDeutsch React root is missing.");
  }

  rootElement.style.display = "contents";

  createRoot(rootElement).render(demoPage ? (
    <LegacyPage
      key={demoPageName}
      pageName={demoPageName}
      markup={demoPage.markup}
      scripts={demoPage.scripts}
      bodyClassName={demoPage.bodyClassName}
    />
  ) : <CatalogApp />);
}

void startApp();
